import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CartDrawer } from "./CartDrawer";
import { WhatsAppButton } from "./WhatsAppButton";
import { SalesControl } from "./SalesControl";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

export const Layout = () => {
  return (
    <div className="noise min-h-screen bg-[#0B0A08] flex flex-col relative">
      <ScrollTop />
      <Header />
      <CartDrawer />
      <main className="flex-1 relative z-[2]">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
      <SalesControl />
    </div>
  );
};
